module.exports = "/_next/static/images/4140fba673d2349dd8e2cc5026e59e05-help-icon.svg";